module.exports = __webpack_public_path__ + "img/about-smile.08229934.svg";